import {SlotLocation} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SlotLocation';
import {DnDDropDirection} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/dnd/DnDDropDirection';
import {SheetId} from '@mintdata/mint-kit/api/models/Identifiers';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {AEmpty} from '@mintdata/mint-kit/api/values/AEmpty';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import {FrameField} from '@mintdata/mint-kit/api/values/frames/FrameField';
import {Frames} from '@mintdata/mint-kit/api/values/frames/Frames';

export class ADragStartedEvent
{
    public readonly dndSource:IFrame;

    public constructor(dndSource:IFrame)
    {
        this.dndSource = dndSource;
    }
}

export class ADropEvent extends ADragStartedEvent
{
    public readonly dndTarget:IFrame;

    public constructor(dndSource:IFrame, dndTartget:IFrame)
    {
        super(dndSource);

        this.dndTarget = dndTartget;
    }

    public static getDnDDataFrame(page:string,
                                  box:string,
                                  x:number,
                                  y:number,
                                  sheetId:SheetId,
                                  slotLocation:SlotLocation,
                                  path:string,
                                  rowIndex:number,
                                  groupName:string,
                                  dropDirection?:DnDDropDirection)
    {
        const fields:Array<FrameField> = [
            new FrameField('page', Type.String),
            new FrameField('box', Type.String),
            new FrameField('x', Type.Number),
            new FrameField('y', Type.Number),
            new FrameField(ADropEvent.SHEET_ID_COLUMN, Type.String),
            new FrameField(ADropEvent.LOCATION_COL_INDEX_COLUMN, Type.Number),
            new FrameField(ADropEvent.LOCATION_ROW_INDEX_COLUMN, Type.Number),
            new FrameField(ADropEvent.PATH_COLUMN, Type.String),
            new FrameField(ADropEvent.ROW_INDEX_COLUMN, Type.Number),
            new FrameField(ADropEvent.GROUP_NAME_COLUMN, Type.String)
        ];
        const data:Array<Array<IValue>> = [
            [
                page ? AString.fromString(page) : AEmpty.Value,
                box ? AString.fromString(box) : AEmpty.Value,
                x ? ANumber.fromNumber(x) : AEmpty.Value,
                y ? ANumber.fromNumber(y) : AEmpty.Value,
                sheetId ? AString.fromString(sheetId) : AEmpty.Value,
                slotLocation ? ANumber.fromNumber(slotLocation.colIndex) : AEmpty.Value,
                slotLocation ? ANumber.fromNumber(slotLocation.rowIndex) : AEmpty.Value,
                path != null ? AString.fromString(path) : AEmpty.Value,
                rowIndex != null ? ANumber.fromNumber(rowIndex) : AEmpty.Value,
                groupName != null ? AString.fromString(groupName) : AEmpty.Value
            ]
        ];

        if( dropDirection )
        {
            fields.push(new FrameField(ADropEvent.DROP_DIRECTION_COLUMN, Type.String));
            data[0].push(AString.fromString(dropDirection));
        }

        return Frames.fromFieldsAndData(fields, data);
    }

    public static readonly SOURCE_COLUMN:string = 'dnd_source';
    public static readonly TARGET_COLUMN:string = 'dnd_target';
    public static readonly SHEET_ID_COLUMN:string = 'sheet_id';
    public static readonly LOCATION_COL_INDEX_COLUMN:string = 'location_col_index';
    public static readonly LOCATION_ROW_INDEX_COLUMN:string = 'location_row_index';
    public static readonly PATH_COLUMN:string = 'path';
    public static readonly ROW_INDEX_COLUMN:string = 'row_index';
    public static readonly GROUP_NAME_COLUMN:string = 'group_name';
    public static readonly DROP_DIRECTION_COLUMN:string = 'drop_direction';
}
